import React, { useEffect, useRef } from "react";
import { useSpring, animated } from "react-spring";
import { interpolateGnBu, scaleSequential, geoPath } from "d3";
import { useAnimatedPath } from "./utils";
import chroma from "chroma-js";
import * as d3 from "d3";

const AnimatedHeatPath = ({ key, index, toggle }) => {

    const colors = ['rgb(10,100,150)', 'rgb(10,240,120)', 'yellow', 'rgb(240,10,10)']

    const color = chroma.scale(colors);
    const pathGenerator = geoPath().projection(null);
    const animationStrokeProps = useAnimatedPath({ toggle, delay: 200, color: "yellow" });

    const animationFillStyle = useSpring({
        fill: toggle ? color(index.value) : "#fff",
        // stroke: "yellow",
        // strokeLinejoin: "round",

        delay: 900
    });

    return (
        pathGenerator ?
            <animated.path {...animationStrokeProps}

                style={{
                    ...animationStrokeProps.style,
                    ...animationFillStyle
                }}
                strokeWidth={key % 5 ? 0.25 : 1}
                // stroke="yellow"
                // strokeLinejoin="round"
                //fill={color(index.value)}
                d={pathGenerator(index)}
            /> : "Calculating the path..."
    )
}

export default AnimatedHeatPath;















// const AnimatedPath = ({ contours, pathGenerator }) => {


//     const pathRef = useRef(null);


//     const colors = ['rgb(10,100,150)', 'rgb(10,240,120)', 'yellow', 'rgb(240,10,10)']

//     const color = chroma.scale(colors);
//     // const pathGenerator = geoPath().projection(null);
//     //const animationStrokeProps = useAnimatedPath({ toggle });



//     useEffect(() => {

//         const pathElement = d3.select(pathRef.current);
//         pathElement.selectAll("path")
//             .data(contours)
//             .join("path")
//             .transition()
//             .ease(d3.easeElasticIn)
//             .duration(1000)
//             .attr("stroke-width", (d, i) => (i % 5 ? 0.25 : 1))
//             .attr("fill", d => color(d.value))
//             .attr("d", d => pathGenerator(d))
//             .delay((d, i) => i * 40)
//             .duration(1000);


//     }, [contours]);


//     return (
//         pathGenerator ?
//             <path
//                 // key={d.id ?? i}
//                 // stroke="yellow"
//                 // strokeLinejoin="round"
//                 // strokeWidth={i % 5 ? 0.25 : 1}
//                 // fill={color(d.value)}
//                 // d={pathGenerator(d)}
//                 ref={pathRef}
//             /> : "calc"
//     )
// }
